import React, { memo } from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import BoxContainer from './BoxContainer';

const EventsInformation = memo(({events,eventCount}) => {

    return (
   
        <List  sx={{pt:0,pb:0,bgcolor: 'background.paper' }}>
            { events.length > 0 &&
                <ListItem 
                    sx={{
                        borderRadius: '8.5px',
                        marginBottom: '10px',
                        border: `1px solid #E37F0999`,
                        bgcolor:'#E37F0933',
                        pt:0,
                        pb:0
                    }} 
                    
                >
                    <ListItemText sx={{ mt:0,mb:0,fontSize:'0.85rem'}}  disableTypography primary={'Events:'} />
                    <ListItemText sx={{ display: 'inline-flex',mb:0}} primary={<ErrorRoundedIcon fontSize='small' sx={{ color : '#1558CD'}} /> } secondary={<Typography  
                    color="#8D8D8D" component="span" fontSize='0.85rem'>{eventCount?.notice?.count}</Typography>} />
                    <ListItemText sx={{ display: 'inline-flex',mb:0}} primary={<ErrorRoundedIcon fontSize='small' sx={{ color : '#E37F09'}} />} secondary={<Typography 
                    color="#8D8D8D" component="span" fontSize='0.85rem'>{eventCount?.warning?.count}</Typography>}  />
                    <ListItemText sx={{ display: 'inline-flex',mb:0}} primary={<ErrorRoundedIcon fontSize='small' sx={{ color : '#C6262A'}} />}  secondary={<Typography color="#8D8D8D" component="span" fontSize='0.85rem'>{eventCount?.fault_shutdown?.count}</Typography>}  />
                </ListItem>
            }
            <BoxContainer maxHeight={'330px'} >
            {events?.length > 0 ? events.map((row,index) => {
                let color = row.type.toLowerCase() === 'alarm' ? '#E37F09' : row.type.toLowerCase() === 'fault' ? '#C6262A' : '#1558CD';
                return (  
                    <ListItem
                        sx={{
                            borderRadius: '10px',
                            marginBottom: '5px',
                            border: `1px solid ${color}`,
                            width: '96%',
                            pt: 0,
                            pb: 0
                        }}
                        key={index}
                    >   
                        <span className='lineBar' style={{border: `2px solid ${color}`}} ></span>
                        <ListItemText
                            primaryTypographyProps={{fontSize:'0.85rem'}} 
                            sx={{ color: color, textTransform: 'capitalize',mt:0.5,mb:0.5 }}
                            primary={row.type.toLowerCase()}
                            secondary={<React.Fragment>
                                <Typography
                                    sx={{ fontWeight: 500 }}
                                    component="span"
                                    variant="body2"
                                    color="text.primary"
                                >
                                    {row.description}
                                </Typography>
                                <Typography
                                    sx={{ display: 'flex',fontSize:'10px' }}
                                    component="span"
                                    variant="body2"
                                    color="#8D8D8D"

                                >
                                    {row.timestamp}
                                </Typography>

                            </React.Fragment>} /> 
                            <ListItemText sx={{ display: 'flex', justifyContent: 'flex-end',position:'relative',bottom:'15px' }} primary={<Typography sx={{ fontSize: '0.60rem' }} component="span">Active </Typography>} />   
                        </ListItem> 
                    
                )
            }) : 
                <ListItem>
                    <ListItemText 
                        primary={<Typography sx={{ fontSize: '0.75rem',fontWeight:'500' }} component="span">No Data Available. </Typography>}>
                    </ListItemText>
                </ListItem> 
            }
            </BoxContainer>
        </List>
    )
});

export default EventsInformation